import React from 'react';

export default function RequiredAsterisk({ className = 'text-red-500 inline-block ml-1' }) {
  return <span className={className} aria-hidden="true">*</span>;
}
